var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "186px",
    height: "169px",
    viewBox: "0 0 186 169",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 200 200 200 200 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Journey-6---Users",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.7-data-subjects---empty-state",
    transform: "translate(-667.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(659.000000, 237.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stamp-document",
    transform: "translate(0.000000, 8.000000)",
    fill: "#F4F6FC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.277311,92.9674023 C193.277311,41.6238302 151.890966,0 100.840336,0 C49.7897059,0 8.40336134,41.6238302 8.40336134,92.9674023 C8.40336134,106.647556 11.3659664,119.623481 16.6394958,131.316456 L185.041176,131.316456 C190.314706,119.623481 193.277311,106.647556 193.277311,92.9674023",
    id: "Fill-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "programmer-male"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181.512605,103.249795 C181.512605,59.2222206 145.769853,23.5294118 101.680672,23.5294118 C57.5914916,23.5294118 21.8487395,59.2222206 21.8487395,103.249795 C21.8487395,114.978657 24.4073529,126.10563 28.9617647,136.134454 L174.39958,136.134454 C178.955987,126.10563 181.512605,114.978657 181.512605,103.249795",
    id: "Fill-1",
    fill: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8487395,137.815126 L178.151261,137.815126",
    id: "Stroke-3",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4453782,137.815126 L18.487395,137.815126",
    id: "Stroke-5",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.512605,137.815126 L186.554622,137.815126",
    id: "Stroke-7",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "129.411765 131.092437 164.705882 131.092437 164.705882 63.8655462 129.411765 63.8655462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-11",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "129.411765 131.092437 164.705882 131.092437 164.705882 63.8655462 129.411765 63.8655462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "129.411765 62.1848739 164.705882 62.1848739 164.705882 58.8235294 129.411765 58.8235294"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-13",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "129.411765 62.1848739 164.705882 62.1848739 164.705882 58.8235294 129.411765 58.8235294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05042,137.815126 L129.411765,137.815126 L129.411765,59.1596639 C129.411765,58.0463866 128.658824,57.1428571 127.731092,57.1428571 C126.801681,57.1428571 126.05042,58.0463866 126.05042,59.1596639 L126.05042,137.815126 Z",
    id: "Fill-14",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05042,137.815126 L129.411765,137.815126 L129.411765,59.1596639 C129.411765,58.0463866 128.658824,57.1428571 127.731092,57.1428571 C126.801681,57.1428571 126.05042,58.0463866 126.05042,59.1596639 L126.05042,137.815126 Z",
    id: "Stroke-15",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.386555,137.815126 L169.747899,137.815126 L169.747899,59.1596639 C169.747899,58.0463866 168.994958,57.1428571 168.067227,57.1428571 C167.137815,57.1428571 166.386555,58.0463866 166.386555,59.1596639 L166.386555,137.815126 Z",
    id: "Fill-16",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.386555,137.815126 L169.747899,137.815126 L169.747899,59.1596639 C169.747899,58.0463866 168.994958,57.1428571 168.067227,57.1428571 C167.137815,57.1428571 166.386555,58.0463866 166.386555,59.1596639 L166.386555,137.815126 Z",
    id: "Stroke-17",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "87.394958 131.092437 122.689076 131.092437 122.689076 63.8655462 87.394958 63.8655462"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-19",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "87.394958 131.092437 122.689076 131.092437 122.689076 63.8655462 87.394958 63.8655462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,73.9495798 L90.7563025,73.9495798 L90.7563025,69.4677871 C90.7563025,68.2308123 91.6466853,67.2268908 92.7482104,67.2268908 L115.655151,67.2268908 C116.754684,67.2268908 117.647059,68.2308123 117.647059,69.4677871 L117.647059,73.9495798 Z",
    id: "Fill-20",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,73.9495798 L90.7563025,73.9495798 L90.7563025,69.4677871 C90.7563025,68.2308123 91.6466853,67.2268908 92.7482104,67.2268908 L115.655151,67.2268908 C116.754684,67.2268908 117.647059,68.2308123 117.647059,69.4677871 L117.647059,73.9495798 Z",
    id: "Stroke-21",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,67.2268908 L100.840336,73.9495798 L119.327731,73.9495798 L119.327731,69.4677871 C119.327731,68.2308123 118.40747,67.2268908 117.273576,67.2268908 L107.002801,67.2268908 Z",
    id: "Fill-22",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,67.2268908 L100.840336,73.9495798 L119.327731,73.9495798 L119.327731,69.4677871 C119.327731,68.2308123 118.40747,67.2268908 117.273576,67.2268908 L107.002801,67.2268908 Z",
    id: "Stroke-23",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,105.882353 L90.7563025,105.882353 L90.7563025,101.40056 C90.7563025,100.163585 91.6466853,99.1596639 92.7482104,99.1596639 L115.655151,99.1596639 C116.754684,99.1596639 117.647059,100.163585 117.647059,101.40056 L117.647059,105.882353 Z",
    id: "Fill-24",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,105.882353 L90.7563025,105.882353 L90.7563025,101.40056 C90.7563025,100.163585 91.6466853,99.1596639 92.7482104,99.1596639 L115.655151,99.1596639 C116.754684,99.1596639 117.647059,100.163585 117.647059,101.40056 L117.647059,105.882353 Z",
    id: "Stroke-25",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,99.1596639 L100.840336,105.882353 L119.327731,105.882353 L119.327731,101.40056 C119.327731,100.163585 118.40747,99.1596639 117.273576,99.1596639 L107.002801,99.1596639 Z",
    id: "Fill-26",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,99.1596639 L100.840336,105.882353 L119.327731,105.882353 L119.327731,101.40056 C119.327731,100.163585 118.40747,99.1596639 117.273576,99.1596639 L107.002801,99.1596639 Z",
    id: "Stroke-27",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,76.7507003 C117.647059,77.9876751 116.754684,78.9915966 115.655151,78.9915966 L92.7482104,78.9915966 C91.6466853,78.9915966 90.7563025,77.9876751 90.7563025,76.7507003 L90.7563025,72.2689076 L117.647059,72.2689076 L117.647059,76.7507003 Z",
    id: "Fill-28",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,76.7507003 C117.647059,77.9876751 116.754684,78.9915966 115.655151,78.9915966 L92.7482104,78.9915966 C91.6466853,78.9915966 90.7563025,77.9876751 90.7563025,76.7507003 L90.7563025,72.2689076 L117.647059,72.2689076 L117.647059,76.7507003 Z",
    id: "Stroke-29",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,72.2689076 L100.840336,78.9915966 L117.273576,78.9915966 C118.40747,78.9915966 119.327731,77.9876751 119.327731,76.7507003 L119.327731,72.2689076 L107.002801,72.2689076 Z",
    id: "Fill-30",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,72.2689076 L100.840336,78.9915966 L117.273576,78.9915966 C118.40747,78.9915966 119.327731,77.9876751 119.327731,76.7507003 L119.327731,72.2689076 L107.002801,72.2689076 Z",
    id: "Stroke-31",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,73.9495798 L134.453782,73.9495798 L134.453782,69.4677871 C134.453782,68.2308123 135.344164,67.2268908 136.445689,67.2268908 L159.35263,67.2268908 C160.452163,67.2268908 161.344538,68.2308123 161.344538,69.4677871 L161.344538,73.9495798 Z",
    id: "Fill-32",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,73.9495798 L134.453782,73.9495798 L134.453782,69.4677871 C134.453782,68.2308123 135.344164,67.2268908 136.445689,67.2268908 L159.35263,67.2268908 C160.452163,67.2268908 161.344538,68.2308123 161.344538,69.4677871 L161.344538,73.9495798 Z",
    id: "Stroke-33",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,67.2268908 L142.857143,73.9495798 L161.344538,73.9495798 L161.344538,69.4677871 C161.344538,68.2308123 160.424276,67.2268908 159.290383,67.2268908 L149.019608,67.2268908 Z",
    id: "Fill-34",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,67.2268908 L142.857143,73.9495798 L161.344538,73.9495798 L161.344538,69.4677871 C161.344538,68.2308123 160.424276,67.2268908 159.290383,67.2268908 L149.019608,67.2268908 Z",
    id: "Stroke-35",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,76.7507003 C161.344538,77.9876751 160.452163,78.9915966 159.35263,78.9915966 L136.445689,78.9915966 C135.344164,78.9915966 134.453782,77.9876751 134.453782,76.7507003 L134.453782,72.2689076 L161.344538,72.2689076 L161.344538,76.7507003 Z",
    id: "Fill-36",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,76.7507003 C161.344538,77.9876751 160.452163,78.9915966 159.35263,78.9915966 L136.445689,78.9915966 C135.344164,78.9915966 134.453782,77.9876751 134.453782,76.7507003 L134.453782,72.2689076 L161.344538,72.2689076 L161.344538,76.7507003 Z",
    id: "Stroke-37",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,72.2689076 L142.857143,78.9915966 L159.290383,78.9915966 C160.424276,78.9915966 161.344538,77.9876751 161.344538,76.7507003 L161.344538,72.2689076 L149.019608,72.2689076 Z",
    id: "Fill-38",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,72.2689076 L142.857143,78.9915966 L159.290383,78.9915966 C160.424276,78.9915966 161.344538,77.9876751 161.344538,76.7507003 L161.344538,72.2689076 L149.019608,72.2689076 Z",
    id: "Stroke-39",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,89.0756303 L134.453782,89.0756303 L134.453782,84.5938375 C134.453782,83.3568627 135.344164,82.3529412 136.445689,82.3529412 L159.35263,82.3529412 C160.452163,82.3529412 161.344538,83.3568627 161.344538,84.5938375 L161.344538,89.0756303 Z",
    id: "Fill-40",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,89.0756303 L134.453782,89.0756303 L134.453782,84.5938375 C134.453782,83.3568627 135.344164,82.3529412 136.445689,82.3529412 L159.35263,82.3529412 C160.452163,82.3529412 161.344538,83.3568627 161.344538,84.5938375 L161.344538,89.0756303 Z",
    id: "Stroke-41",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,82.3529412 L142.857143,89.0756303 L161.344538,89.0756303 L161.344538,84.5938375 C161.344538,83.3568627 160.424276,82.3529412 159.290383,82.3529412 L149.019608,82.3529412 Z",
    id: "Fill-42",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,82.3529412 L142.857143,89.0756303 L161.344538,89.0756303 L161.344538,84.5938375 C161.344538,83.3568627 160.424276,82.3529412 159.290383,82.3529412 L149.019608,82.3529412 Z",
    id: "Stroke-43",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,93.557423 C161.344538,94.7943978 160.452163,95.7983193 159.35263,95.7983193 L136.445689,95.7983193 C135.344164,95.7983193 134.453782,94.7943978 134.453782,93.557423 L134.453782,89.0756303 L161.344538,89.0756303 L161.344538,93.557423 Z",
    id: "Fill-44",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,93.557423 C161.344538,94.7943978 160.452163,95.7983193 159.35263,95.7983193 L136.445689,95.7983193 C135.344164,95.7983193 134.453782,94.7943978 134.453782,93.557423 L134.453782,89.0756303 L161.344538,89.0756303 L161.344538,93.557423 Z",
    id: "Stroke-45",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,89.0756303 L142.857143,95.7983193 L159.290383,95.7983193 C160.424276,95.7983193 161.344538,94.7943978 161.344538,93.557423 L161.344538,89.0756303 L149.019608,89.0756303 Z",
    id: "Fill-46",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,89.0756303 L142.857143,95.7983193 L159.290383,95.7983193 C160.424276,95.7983193 161.344538,94.7943978 161.344538,93.557423 L161.344538,89.0756303 L149.019608,89.0756303 Z",
    id: "Stroke-47",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,121.008403 L90.7563025,121.008403 L90.7563025,116.526611 C90.7563025,115.289636 91.6466853,114.285714 92.7482104,114.285714 L115.655151,114.285714 C116.754684,114.285714 117.647059,115.289636 117.647059,116.526611 L117.647059,121.008403 Z",
    id: "Fill-48",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,121.008403 L90.7563025,121.008403 L90.7563025,116.526611 C90.7563025,115.289636 91.6466853,114.285714 92.7482104,114.285714 L115.655151,114.285714 C116.754684,114.285714 117.647059,115.289636 117.647059,116.526611 L117.647059,121.008403 Z",
    id: "Stroke-49",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,114.285714 L100.840336,121.008403 L119.327731,121.008403 L119.327731,116.526611 C119.327731,115.289636 118.40747,114.285714 117.273576,114.285714 L107.002801,114.285714 Z",
    id: "Fill-50",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,114.285714 L100.840336,121.008403 L119.327731,121.008403 L119.327731,116.526611 C119.327731,115.289636 118.40747,114.285714 117.273576,114.285714 L107.002801,114.285714 Z",
    id: "Stroke-51",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,125.490196 C117.647059,126.727171 116.754684,127.731092 115.655151,127.731092 L92.7482104,127.731092 C91.6466853,127.731092 90.7563025,126.727171 90.7563025,125.490196 L90.7563025,121.008403 L117.647059,121.008403 L117.647059,125.490196 Z",
    id: "Fill-52",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,125.490196 C117.647059,126.727171 116.754684,127.731092 115.655151,127.731092 L92.7482104,127.731092 C91.6466853,127.731092 90.7563025,126.727171 90.7563025,125.490196 L90.7563025,121.008403 L117.647059,121.008403 L117.647059,125.490196 Z",
    id: "Stroke-53",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,121.008403 L100.840336,127.731092 L117.273576,127.731092 C118.40747,127.731092 119.327731,126.727171 119.327731,125.490196 L119.327731,121.008403 L107.002801,121.008403 Z",
    id: "Fill-54",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,121.008403 L100.840336,127.731092 L117.273576,127.731092 C118.40747,127.731092 119.327731,126.727171 119.327731,125.490196 L119.327731,121.008403 L107.002801,121.008403 Z",
    id: "Stroke-55",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,89.0756303 L90.7563025,89.0756303 L90.7563025,84.5938375 C90.7563025,83.3568627 91.6466853,82.3529412 92.7482104,82.3529412 L115.655151,82.3529412 C116.754684,82.3529412 117.647059,83.3568627 117.647059,84.5938375 L117.647059,89.0756303 Z",
    id: "Fill-56",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,89.0756303 L90.7563025,89.0756303 L90.7563025,84.5938375 C90.7563025,83.3568627 91.6466853,82.3529412 92.7482104,82.3529412 L115.655151,82.3529412 C116.754684,82.3529412 117.647059,83.3568627 117.647059,84.5938375 L117.647059,89.0756303 Z",
    id: "Stroke-57",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,82.3529412 L100.840336,89.0756303 L119.327731,89.0756303 L119.327731,84.5938375 C119.327731,83.3568627 118.40747,82.3529412 117.273576,82.3529412 L107.002801,82.3529412 Z",
    id: "Fill-58",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,82.3529412 L100.840336,89.0756303 L119.327731,89.0756303 L119.327731,84.5938375 C119.327731,83.3568627 118.40747,82.3529412 117.273576,82.3529412 L107.002801,82.3529412 Z",
    id: "Stroke-59",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,93.557423 C117.647059,94.7943978 116.754684,95.7983193 115.655151,95.7983193 L92.7482104,95.7983193 C91.6466853,95.7983193 90.7563025,94.7943978 90.7563025,93.557423 L90.7563025,89.0756303 L117.647059,89.0756303 L117.647059,93.557423 Z",
    id: "Fill-60",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,93.557423 C117.647059,94.7943978 116.754684,95.7983193 115.655151,95.7983193 L92.7482104,95.7983193 C91.6466853,95.7983193 90.7563025,94.7943978 90.7563025,93.557423 L90.7563025,89.0756303 L117.647059,89.0756303 L117.647059,93.557423 Z",
    id: "Stroke-61",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,89.0756303 L100.840336,95.7983193 L117.273576,95.7983193 C118.40747,95.7983193 119.327731,94.7943978 119.327731,93.557423 L119.327731,89.0756303 L107.002801,89.0756303 Z",
    id: "Fill-62",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,89.0756303 L100.840336,95.7983193 L117.273576,95.7983193 C118.40747,95.7983193 119.327731,94.7943978 119.327731,93.557423 L119.327731,89.0756303 L107.002801,89.0756303 Z",
    id: "Stroke-63",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,105.882353 L134.453782,105.882353 L134.453782,101.40056 C134.453782,100.163585 135.344164,99.1596639 136.445689,99.1596639 L159.35263,99.1596639 C160.452163,99.1596639 161.344538,100.163585 161.344538,101.40056 L161.344538,105.882353 Z",
    id: "Fill-64",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,105.882353 L134.453782,105.882353 L134.453782,101.40056 C134.453782,100.163585 135.344164,99.1596639 136.445689,99.1596639 L159.35263,99.1596639 C160.452163,99.1596639 161.344538,100.163585 161.344538,101.40056 L161.344538,105.882353 Z",
    id: "Stroke-65",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,99.1596639 L142.857143,105.882353 L161.344538,105.882353 L161.344538,101.40056 C161.344538,100.163585 160.424276,99.1596639 159.290383,99.1596639 L149.019608,99.1596639 Z",
    id: "Fill-66",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,99.1596639 L142.857143,105.882353 L161.344538,105.882353 L161.344538,101.40056 C161.344538,100.163585 160.424276,99.1596639 159.290383,99.1596639 L149.019608,99.1596639 Z",
    id: "Stroke-67",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,108.683473 C161.344538,109.920448 160.452163,110.92437 159.35263,110.92437 L136.445689,110.92437 C135.344164,110.92437 134.453782,109.920448 134.453782,108.683473 L134.453782,104.201681 L161.344538,104.201681 L161.344538,108.683473 Z",
    id: "Fill-68",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,108.683473 C161.344538,109.920448 160.452163,110.92437 159.35263,110.92437 L136.445689,110.92437 C135.344164,110.92437 134.453782,109.920448 134.453782,108.683473 L134.453782,104.201681 L161.344538,104.201681 L161.344538,108.683473 Z",
    id: "Stroke-69",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,104.201681 L142.857143,110.92437 L159.290383,110.92437 C160.424276,110.92437 161.344538,109.920448 161.344538,108.683473 L161.344538,104.201681 L149.019608,104.201681 Z",
    id: "Fill-70",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,104.201681 L142.857143,110.92437 L159.290383,110.92437 C160.424276,110.92437 161.344538,109.920448 161.344538,108.683473 L161.344538,104.201681 L149.019608,104.201681 Z",
    id: "Stroke-71",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,121.008403 L134.453782,121.008403 L134.453782,116.526611 C134.453782,115.289636 135.344164,114.285714 136.445689,114.285714 L159.35263,114.285714 C160.452163,114.285714 161.344538,115.289636 161.344538,116.526611 L161.344538,121.008403 Z",
    id: "Fill-72",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,121.008403 L134.453782,121.008403 L134.453782,116.526611 C134.453782,115.289636 135.344164,114.285714 136.445689,114.285714 L159.35263,114.285714 C160.452163,114.285714 161.344538,115.289636 161.344538,116.526611 L161.344538,121.008403 Z",
    id: "Stroke-73",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,114.285714 L142.857143,121.008403 L161.344538,121.008403 L161.344538,116.526611 C161.344538,115.289636 160.424276,114.285714 159.290383,114.285714 L149.019608,114.285714 Z",
    id: "Fill-74",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,114.285714 L142.857143,121.008403 L161.344538,121.008403 L161.344538,116.526611 C161.344538,115.289636 160.424276,114.285714 159.290383,114.285714 L149.019608,114.285714 Z",
    id: "Stroke-75",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,125.490196 C161.344538,126.727171 160.452163,127.731092 159.35263,127.731092 L136.445689,127.731092 C135.344164,127.731092 134.453782,126.727171 134.453782,125.490196 L134.453782,121.008403 L161.344538,121.008403 L161.344538,125.490196 Z",
    id: "Fill-76",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.344538,125.490196 C161.344538,126.727171 160.452163,127.731092 159.35263,127.731092 L136.445689,127.731092 C135.344164,127.731092 134.453782,126.727171 134.453782,125.490196 L134.453782,121.008403 L161.344538,121.008403 L161.344538,125.490196 Z",
    id: "Stroke-77",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,121.008403 L142.857143,127.731092 L159.290383,127.731092 C160.424276,127.731092 161.344538,126.727171 161.344538,125.490196 L161.344538,121.008403 L149.019608,121.008403 Z",
    id: "Fill-78",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.019608,121.008403 L142.857143,127.731092 L159.290383,127.731092 C160.424276,127.731092 161.344538,126.727171 161.344538,125.490196 L161.344538,121.008403 L149.019608,121.008403 Z",
    id: "Stroke-79",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,108.683473 C117.647059,109.920448 116.754684,110.92437 115.655151,110.92437 L92.7482104,110.92437 C91.6466853,110.92437 90.7563025,109.920448 90.7563025,108.683473 L90.7563025,104.201681 L117.647059,104.201681 L117.647059,108.683473 Z",
    id: "Fill-80",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.647059,108.683473 C117.647059,109.920448 116.754684,110.92437 115.655151,110.92437 L92.7482104,110.92437 C91.6466853,110.92437 90.7563025,109.920448 90.7563025,108.683473 L90.7563025,104.201681 L117.647059,104.201681 L117.647059,108.683473 Z",
    id: "Stroke-81",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,104.201681 L100.840336,110.92437 L117.273576,110.92437 C118.40747,110.92437 119.327731,109.920448 119.327731,108.683473 L119.327731,104.201681 L107.002801,104.201681 Z",
    id: "Fill-82",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.002801,104.201681 L100.840336,110.92437 L117.273576,110.92437 C118.40747,110.92437 119.327731,109.920448 119.327731,108.683473 L119.327731,104.201681 L107.002801,104.201681 Z",
    id: "Stroke-83",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-84",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "87.394958 62.1848739 122.689076 62.1848739 122.689076 58.8235294 87.394958 58.8235294"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-85",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)",
    points: "87.394958 62.1848739 122.689076 62.1848739 122.689076 58.8235294 87.394958 58.8235294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0336134,137.815126 L87.394958,137.815126 L87.394958,59.1596639 C87.394958,58.0463866 86.6436975,57.1428571 85.7142857,57.1428571 C84.7865546,57.1428571 84.0336134,58.0463866 84.0336134,59.1596639 L84.0336134,137.815126 Z",
    id: "Fill-86",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0336134,137.815126 L87.394958,137.815126 L87.394958,59.1596639 C87.394958,58.0463866 86.6436975,57.1428571 85.7142857,57.1428571 C84.7865546,57.1428571 84.0336134,58.0463866 84.0336134,59.1596639 L84.0336134,137.815126 Z",
    id: "Stroke-87",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.689076,137.815126 L126.05042,137.815126 L126.05042,59.1596639 C126.05042,58.0463866 125.297479,57.1428571 124.369748,57.1428571 C123.440336,57.1428571 122.689076,58.0463866 122.689076,59.1596639 L122.689076,137.815126 Z",
    id: "Fill-88",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.689076,137.815126 L126.05042,137.815126 L126.05042,59.1596639 C126.05042,58.0463866 125.297479,57.1428571 124.369748,57.1428571 C123.440336,57.1428571 122.689076,58.0463866 122.689076,59.1596639 L122.689076,137.815126 Z",
    id: "Stroke-89",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4369748,112.605042 C95.6127916,112.605042 98.1866431,115.173401 98.1866431,118.342441 L98.1866431,159.65171 C98.1866431,164.299502 101.962425,168.067227 106.622156,168.067227 L114.285714,168.067227",
    id: "Stroke-90",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.686675,169.747899 L122.689076,169.747899 L122.689076,164.705882 L116.686675,164.705882 C115.360927,164.705882 114.285714,165.834856 114.285714,167.226891 C114.285714,168.618926 115.360927,169.747899 116.686675,169.747899",
    id: "Fill-91",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.686675,169.747899 L122.689076,169.747899 L122.689076,164.705882 L116.686675,164.705882 C115.360927,164.705882 114.285714,165.834856 114.285714,167.226891 C114.285714,168.618926 115.360927,169.747899 116.686675,169.747899 Z",
    id: "Stroke-92",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.966387,131.092437 L115.966387,144.200402 C115.966387,147.170442 118.438135,149.579832 121.489652,149.579832 L126.643599,149.579832 C131.886264,149.579832 136.134454,153.717391 136.134454,158.823529 C136.134454,163.927658 131.886264,168.067227 126.643599,168.067227 L121.898171,168.067227",
    id: "Stroke-93",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.243697,131.092437 L109.243697,144.037632 C109.243697,147.0981 111.648277,149.579832 114.617952,149.579832 L126.05042,149.579832",
    id: "Stroke-94",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3361345,173.109244 C40.3361345,174.966265 50.4929485,176.470588 63.0252101,176.470588 C75.5554987,176.470588 85.7142857,174.966265 85.7142857,173.109244 C85.7142857,171.252223 75.5554987,169.747899 63.0252101,169.747899 C50.4929485,169.747899 40.3361345,171.252223 40.3361345,173.109244",
    id: "Fill-95",
    fill: "#F4F6FC",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3063995,48.7394958 C50.5946432,48.7394958 44.3438914,54.8662248 44.3438914,62.42497 L44.3438914,64.2516833 C43.0265591,64.5234094 42.0168067,65.6142805 42.0168067,66.9867947 C42.0168067,68.4604624 43.1722549,69.6326531 44.6373064,69.7814082 C45.9526152,75.9993737 51.5720188,80.6722689 58.3063995,80.6722689 C66.0181558,80.6722689 72.2689076,74.54554 72.2689076,66.9867947 L72.2689076,62.42497 C72.2689076,54.8662248 66.0181558,48.7394958 58.3063995,48.7394958",
    id: "Fill-96",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3063995,48.7394958 C50.5946432,48.7394958 44.3438914,54.8662248 44.3438914,62.42497 L44.3438914,64.2516833 C43.0265591,64.5234094 42.0168067,65.6142805 42.0168067,66.9867947 C42.0168067,68.4604624 43.1722549,69.6326531 44.6373064,69.7814082 C45.9526152,75.9993737 51.5720188,80.6722689 58.3063995,80.6722689 C66.0181558,80.6722689 72.2689076,74.54554 72.2689076,66.9867947 L72.2689076,62.42497 C72.2689076,54.8662248 66.0181558,48.7394958 58.3063995,48.7394958 Z",
    id: "Stroke-97",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2941176,107.290484 C35.2941176,95.3737076 45.0755533,85.7142857 57.1428571,85.7142857 C69.2081611,85.7142857 78.9915966,95.3737076 78.9915966,107.290484 L78.9915966,110.697252 L73.2419284,110.697252 L73.2359287,127.731092 L43.3436533,127.731092 L43.3356537,110.697252 L35.2941176,110.697252 L35.2941176,107.290484 Z",
    id: "Fill-98",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2941176,107.290484 C35.2941176,95.3737076 45.0755533,85.7142857 57.1428571,85.7142857 C69.2081611,85.7142857 78.9915966,95.3737076 78.9915966,107.290484 L78.9915966,110.697252 L73.2419284,110.697252 L73.2359287,127.731092 L43.3436533,127.731092 L43.3356537,110.697252 L35.2941176,110.697252 L35.2941176,107.290484 Z",
    id: "Stroke-99",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8235294,63.8655462 C58.8235294,64.7936205 58.0713677,65.5462185 57.1418828,65.5462185 C56.2143466,65.5462185 55.4621849,64.7936205 55.4621849,63.8655462 C55.4621849,62.937472 56.2143466,62.1848739 57.1418828,62.1848739 C58.0713677,62.1848739 58.8235294,62.937472 58.8235294,63.8655462",
    id: "Fill-100",
    fill: "#7450C8",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8655462,63.8655462 C63.8655462,64.7936205 64.617708,65.5462185 65.5452442,65.5462185 C66.474729,65.5462185 67.2268908,64.7936205 67.2268908,63.8655462 C67.2268908,62.937472 66.474729,62.1848739 65.5452442,62.1848739 C64.617708,62.1848739 63.8655462,62.937472 63.8655462,63.8655462",
    id: "Fill-101",
    fill: "#7450C8",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7815126,68.9065887 C53.7815126,69.8360736 53.0293509,70.5882353 52.1018146,70.5882353 C51.1742784,70.5882353 50.4201681,69.8360736 50.4201681,68.9065887 C50.4201681,67.9790525 51.1742784,67.2268908 52.1018146,67.2268908 C53.0293509,67.2268908 53.7815126,67.9790525 53.7815126,68.9065887",
    id: "Fill-102",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1428571,72.2689076 C59.1772013,73.4386555 61.831202,73.4386555 63.8655462,72.2689076",
    id: "Stroke-103",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9495798,59.1201186 C73.9495798,50.6031077 67.1767516,43.697479 58.8235294,43.697479 C50.4682836,43.697479 43.697479,50.6031077 43.697479,59.1201186 L43.697479,63.8655462 C47.8315955,62.7287068 50.2983053,60.1414172 51.8422754,56.7474048 C58.360136,61.2225494 66.9683258,60.3064755 73.9495798,59.1201186",
    id: "Fill-104",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9495798,59.1201186 C73.9495798,50.6031077 67.1767516,43.697479 58.8235294,43.697479 C50.4682836,43.697479 43.697479,50.6031077 43.697479,59.1201186 L43.697479,63.8655462 C47.8315955,62.7287068 50.2983053,60.1414172 51.8422754,56.7474048 C58.360136,61.2225494 66.9683258,60.3064755 73.9495798,59.1201186 Z",
    id: "Stroke-105",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4201681,53.7815126 C50.4201681,53.7815126 51.0705152,54.8688345 52.1008403,55.4621849",
    id: "Stroke-106",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2941176,133.894532 C35.2941176,136.059432 37.1752179,137.815126 39.4947544,137.815126 C41.8163787,137.815126 43.697479,136.059432 43.697479,133.894532 L43.697479,110.92437 L35.2941176,110.92437 L35.2941176,133.894532 Z",
    id: "Fill-107",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2941176,133.894532 C35.2941176,136.059432 37.1752179,137.815126 39.4947544,137.815126 C41.8163787,137.815126 43.697479,136.059432 43.697479,133.894532 L43.697479,110.92437 L35.2941176,110.92437 L35.2941176,133.894532 Z",
    id: "Stroke-108",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.697479,110.92437 L43.697479,104.201681",
    id: "Stroke-109",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9495798,110.92437 L73.9495798,104.201681",
    id: "Stroke-110",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1008403,86.2111801 L58.0972087,94.1176471 L63.8655462,86.783235 C61.6633588,86.092176 59.3175964,85.7142857 56.8831553,85.7142857 C55.2425996,85.7142857 53.6442718,85.8896602 52.1008403,86.2111801",
    id: "Fill-111",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1008403,86.2111801 L58.0972087,94.1176471 L63.8655462,86.783235 C61.6633588,86.092176 59.3175964,85.7142857 56.8831553,85.7142857 C55.2425996,85.7142857 53.6442718,85.8896602 52.1008403,86.2111801 Z",
    id: "Stroke-112",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8235294,93.324244 L63.22449,94.0889224 C64.5811928,94.3228751 65.7527014,93.0924577 65.5154865,91.6822433 L64.5083636,85.7142857 L58.8235294,93.324244 Z",
    id: "Fill-113",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8235294,93.324244 L63.22449,94.0889224 C64.5811928,94.3228751 65.7527014,93.0924577 65.5154865,91.6822433 L64.5083636,85.7142857 L58.8235294,93.324244 Z",
    id: "Stroke-114",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0001336,85.7142857 L52.1204727,91.9150363 C51.9359285,93.2077009 53.0801027,94.3064659 54.3883163,94.0903485 L58.8235294,93.3632246 L53.0001336,85.7142857 Z",
    id: "Fill-115",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.0001336,85.7142857 L52.1204727,91.9150363 C51.9359285,93.2077009 53.0801027,94.3064659 54.3883163,94.0903485 L58.8235294,93.3632246 L53.0001336,85.7142857 Z",
    id: "Stroke-116",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8235294,92.4369748 L58.8235294,127.731092",
    id: "Stroke-117",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4036473,100.840336 L67.579546,100.840336 C66.4571492,100.840336 65.5462185,101.713311 65.5462185,102.788942 L65.5462185,115.698453 C65.5462185,116.774084 66.4571492,117.647059 67.579546,117.647059 L90.4036473,117.647059 C91.5260441,117.647059 92.4369748,116.774084 92.4369748,115.698453 L92.4369748,102.788942 C92.4369748,101.713311 91.5260441,100.840336 90.4036473,100.840336",
    id: "Fill-118",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4036473,100.840336 L67.579546,100.840336 C66.4571492,100.840336 65.5462185,101.713311 65.5462185,102.788942 L65.5462185,115.698453 C65.5462185,116.774084 66.4571492,117.647059 67.579546,117.647059 L90.4036473,117.647059 C91.5260441,117.647059 92.4369748,116.774084 92.4369748,115.698453 L92.4369748,102.788942 C92.4369748,101.713311 91.5260441,100.840336 90.4036473,100.840336 Z",
    id: "Stroke-119",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6722689,111.764706 C80.6722689,113.156741 79.5432956,114.285714 78.1512605,114.285714 C76.7592254,114.285714 75.6302521,113.156741 75.6302521,111.764706 C75.6302521,110.372671 76.7592254,109.243697 78.1512605,109.243697 C79.5432956,109.243697 80.6722689,110.372671 80.6722689,111.764706",
    id: "Fill-120",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6722689,111.764706 C80.6722689,113.156741 79.5432956,114.285714 78.1512605,114.285714 C76.7592254,114.285714 75.6302521,113.156741 75.6302521,111.764706 C75.6302521,110.372671 76.7592254,109.243697 78.1512605,109.243697 C79.5432956,109.243697 80.6722689,110.372671 80.6722689,111.764706 Z",
    id: "Stroke-121",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9915966,106.848739 L79.9579832,105.882353",
    id: "Stroke-122",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1584561,122.689076 L76.1440649,122.689076 C74.9307942,122.689076 73.9495798,121.745561 73.9495798,120.582828 L73.9495798,119.072853 C73.9495798,118.285422 74.6128588,117.647059 75.4332783,117.647059 L80.8692427,117.647059 C81.687835,117.647059 82.3529412,118.285422 82.3529412,119.072853 L82.3529412,120.582828 C82.3529412,121.745561 81.3717268,122.689076 80.1584561,122.689076",
    id: "Fill-123",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1584561,122.689076 L76.1440649,122.689076 C74.9307942,122.689076 73.9495798,121.745561 73.9495798,120.582828 L73.9495798,119.072853 C73.9495798,118.285422 74.6128588,117.647059 75.4332783,117.647059 L80.8692427,117.647059 C81.687835,117.647059 82.3529412,118.285422 82.3529412,119.072853 L82.3529412,120.582828 C82.3529412,121.745561 81.3717268,122.689076 80.1584561,122.689076 Z",
    id: "Stroke-124",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7860375,162.88715 C73.1826537,162.88715 73.5711756,162.920679 73.9495798,162.983792 L73.9495798,127.731092 L43.697479,127.731092 L43.697479,162.88715 L53.0058177,162.88715 C53.4874231,162.88715 53.9589107,162.934485 54.4121863,163.02521 L55.2033951,141.337917 C55.2762429,139.440574 56.8748489,137.93769 58.8235294,137.93769 C60.7722099,137.93769 62.3708159,139.440574 62.4436638,141.337917 L63.4776988,162.88715 L72.7860375,162.88715 Z",
    id: "Fill-125",
    fill: "#DFE4EE",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7860375,162.88715 C73.1826537,162.88715 73.5711756,162.920679 73.9495798,162.983792 L73.9495798,127.731092 L43.697479,127.731092 L43.697479,162.88715 L53.0058177,162.88715 C53.4874231,162.88715 53.9589107,162.934485 54.4121863,163.02521 L55.2033951,141.337917 C55.2762429,139.440574 56.8748489,137.93769 58.8235294,137.93769 C60.7722099,137.93769 62.3708159,139.440574 62.4436638,141.337917 L63.4776988,162.88715 L72.7860375,162.88715 Z",
    id: "Stroke-126",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6722689,169.747899 C80.6722689,166.035806 77.4466308,163.02521 73.4693878,163.02521 L63.8655462,163.02521 L63.8655462,167.507003 C63.8655462,168.744367 64.9407589,169.747899 66.2665066,169.747899 L80.6722689,169.747899 Z",
    id: "Fill-127",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6722689,169.747899 C80.6722689,166.035806 77.4466308,163.02521 73.4693878,163.02521 L63.8655462,163.02521 L63.8655462,167.507003 C63.8655462,168.744367 64.9407589,169.747899 66.2665066,169.747899 L80.6722689,169.747899 Z",
    id: "Stroke-128",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042017,169.747899 C60.5042017,166.035806 57.2806514,163.02521 53.3013205,163.02521 L43.697479,163.02521 L43.697479,167.507003 C43.697479,168.744367 44.7726917,169.747899 46.0984394,169.747899 L60.5042017,169.747899 Z",
    id: "Fill-129",
    fill: "#FFFFFF",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5042017,169.747899 C60.5042017,166.035806 57.2806514,163.02521 53.3013205,163.02521 L43.697479,163.02521 L43.697479,167.507003 C43.697479,168.744367 44.7726917,169.747899 46.0984394,169.747899 L60.5042017,169.747899 Z",
    id: "Stroke-130",
    stroke: "#7450C8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#mask-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.3ff60ba7aa390574be18e587eefb660c.svg";
export { ForwardRef as ReactComponent };